// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Tooltip from "components/layout/Tooltip";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";

// ** Utils & Helpers
import useSelectorKids from "hooks/selectors/useSelectorKids";

// #####################################################

const Kids = ({ data, onAccept, isBan, tooltipInfo }) => {
	const { t } = useTranslation(["filtersAndSelectors"]);

	const { items, selected, setSelected } = useSelectorKids({
		initial: data,
	});

	// #####################################################

	return (
		<Tooltip text={tooltipInfo}>
			<UserpanelRow>
				<SelectorSelectSingle
					label={t("filtersAndSelectors:kidsLabel")}
					emptyText={t("common:choose")}
					items={items}
					selected={selected}
					onAccept={(value) => {
						setSelected(value);
						onAccept(value);
					}}
					withMobileVersion
					activatorStyleOptions={{
						noPad: true,
						noTopMargin: true,
						flex1: true,
					}}
					disabled={isBan}
				/>
			</UserpanelRow>
		</Tooltip>
	);
};

// #####################################################

export default Kids;

// #####################################################
